export default [{
    path: "/manage/orderRefund",
    component: (resolve) => require(["../page.vue"], resolve),
    meta: {
        title: "门店退款",
        keepAlive: false,
    },
}, ];